const SOURCETREEAPP_VANITY_DOMAIN = "sourcetreeapp.com";
const SOURCETREEAPP_STG_DOMAIN = "sourcetreeapp.stg.internal.atlassian.com";
const BITBUCKET_VANITY_DOMAIN = "bitbucket.org";

/**
 * Checks whether a hostname matches a vanity domain (bare or www).
 * Other subdomains (e.g. `foo.bitbucket.org`) are intentionally not matched;
 * use a path-based segment on the WAC host instead.
 */
function isVanityDomain(hostname: string | undefined, domain: string): boolean {
    if (!hostname) {
        return false;
    }
    const host = hostname.toLowerCase();
    return host === domain || host === `www.${domain}`;
}

export function isSourcetreeHostname(hostname: string | undefined): boolean {
    return (
        isVanityDomain(hostname, SOURCETREEAPP_VANITY_DOMAIN) ||
        hostname === SOURCETREEAPP_STG_DOMAIN
    );
}

export function isBitbucketHostname(hostname: string | undefined): boolean {
    return isVanityDomain(hostname, BITBUCKET_VANITY_DOMAIN);
}

/**
 *
 * NOTE: update to hostname for lookup in routing table no longer needed after diectToUip is enabled
 * This is because nginx handles all routing directly to <wac_url>/<domain_name> which correctly serves the corresponding uniform page
 */

/** Returns true for any vanity domain (sourcetreeapp.com, bitbucket.org). */
export function isVanityHostname(hostname: string | undefined): boolean {
    return isBitbucketHostname(hostname);
}

/**
 * Returns the routing-table prefix segment for a vanity hostname,
 * or `null` for standard WAC domains.
 */
export function getVanitySegment(hostname: string | undefined): string | null {
    if (isBitbucketHostname(hostname)) return "bitbucketapp";
    return null;
}
